
import React from "react";
import { Link } from "react-router-dom";

export const NavLogo = () => {
  return (
    <div className="flex items-center gap-2">
      <img 
        src="/lovable-uploads/44a926d2-0aaa-4f66-8c86-3833b793fd41.png" 
        alt="Dove Bot Logo" 
        className="h-8 w-8"
      />
      <Link to="/" className="text-xl font-semibold text-primary hover:text-primary/80">
        Dove Bot
      </Link>
    </div>
  );
};
